import { render, staticRenderFns } from "./NeedsUpdatesItem.vue?vue&type=template&id=bbef25ce&scoped=true&"
import script from "./NeedsUpdatesItem.vue?vue&type=script&setup=true&lang=js&"
export * from "./NeedsUpdatesItem.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbef25ce",
  null
  
)

export default component.exports